import FucinoLogo from "./FucinoLogo";

export default function Header({ site, cartCount, onCartOpen }) {
  return (
    <header className="site-header" data-testid="site-header">
      <div className="header-inner">
        <a className="header-brand" href="#top" data-testid="header-fucino-logo">
          <FucinoLogo src={site.logo_url} className="header-logo" testId="header-logo-image" />
          <span className="header-wordmark">Fucino Pizza</span>
        </a>
        <div className="header-meta"><i className="status-dot" /> Open for pickup + delivery</div>
        <nav className="header-nav" aria-label="Main navigation">
          <a href="#menu" data-testid="header-nav-menu-link">Menu</a>
          <a href="#craft" data-testid="header-nav-craft-link">Our story</a>
          <a href="#live-hearth" data-testid="header-nav-video-link">Film</a>
          <a href="#location" data-testid="header-nav-location-link">Location</a>
          <a className="header-order-link" href={site.order_url} target="_blank" rel="noreferrer" data-testid="header-order-link">Order online ↗</a>
          <button className="header-order-link" type="button" onClick={onCartOpen} data-testid="header-cart-trigger-button">Bag ({cartCount})</button>
        </nav>
      </div>
    </header>
  );
}
